import { ROUTES } from "@constants";
import { saveCart } from "@utils/storage";
import "./css/payment.scss";
import { ICart } from "../cart/ICart";
import { useHistory } from "react-router-dom";
import { HandleErrorAndLoading } from "@common/HandleErrorAndLoading/HandleErrorAndLoading";
import { useGetPaymentProvider } from "@features/summary/hook/useGetPaymentProvider";
import { keycloakUtils } from "itsf-ui-common";
import { NoAuthPaymentIframe } from "@common/PaymentIframe/NoAuthPaymentIframe";
import { AuthPaymentIframe } from "@common/PaymentIframe";
import { useCallback } from "react";
import { Card, Stack } from "@mui/material";

interface IParams {
    cart: ICart;
}

export const Payment = (props: IParams) => {
    const { cart } = props;
    const { push } = useHistory();

    const { isNewPaymentProvider, paymentProviderState } = useGetPaymentProvider();

    const isAuthenticated = keycloakUtils.isAuthenticated();

    const callbackValidCart = useCallback(() => {
        saveCart(cart);
        push(ROUTES.CONFIRMATION_PAGE_URL);
    }, [cart, push]);

    const renderIframe = useCallback(() => {
        if (isNewPaymentProvider !== undefined) {
            if (isAuthenticated) {
                return (
                    <AuthPaymentIframe
                        isNewPaymentProvider={isNewPaymentProvider}
                        successCallback={callbackValidCart}
                    />
                );
            }

            return (
                <NoAuthPaymentIframe isNewPaymentProvider={isNewPaymentProvider} successCallback={callbackValidCart} />
            );
        }

        return undefined;
    }, [callbackValidCart, isAuthenticated, isNewPaymentProvider]);

    return (
        <Card className="xtest_payment_iframe" elevation={2}>
            <Stack className="payment-container" justifyContent="center" spacing={2}>
                <HandleErrorAndLoading error={paymentProviderState.error} isLoading={paymentProviderState.isLoading}>
                    {renderIframe()}
                </HandleErrorAndLoading>
            </Stack>
        </Card>
    );
};
